import React, { useState } from 'react';
import { IEnterpriseInfo, IUserInfo, VERSION_TYPE, EnterpriseRoleType as RoleType } from '@umu/umu-types';
import { localStorageHelper } from '@umu/umu-storage';
import { customFormatDateTime } from '@umu/umu-util';
import { commonLang, isSystem } from '@umu/ukit-lang';
import './index.scss';

interface IProps {
    userInfo: IUserInfo;
}
const defaultTips = {
    show: false,
    tips: ''
}

const onTeamRenewUrls = () => {
    let urls = '/plan/payment?plan=3&purchase=2&platform=mobile';
    if (!isSystem('CN')) {
        urls = '/plan/subscription?plan=3&purchase=2&platform=twww'
    }
    return urls;
}
const tipsShowRoleList = [RoleType.LEARNER];// 学员不展示提示信息
const tipsAdminRoleList = [RoleType.ADMIN, RoleType.SUB_ADMIN];// 管理员类型列表
const instituteList = [VERSION_TYPE.INSTITUTE, VERSION_TYPE.INSTITUTE_COMMON];// 机构版类型
const commericalList = [VERSION_TYPE.COMMERICAL, VERSION_TYPE.COMMERICAL_TRIAL]// 团队版列表
const enterpriseList = [VERSION_TYPE.ENTERPRISE]// 企业版本列表-不包含试用版

const getEnterpriseExpireMessage = (enterpriseInfo: IEnterpriseInfo, dayTime: number) => {
    const { expire_time: expireTime = dayTime, version_type, role_type } = enterpriseInfo;
    const dateLabel = customFormatDateTime(+expireTime * 1000 || 0, 'yyyy-MM-dd');
    const isExpire = dayTime > expireTime;
    const isAdmin = tipsAdminRoleList.includes(Number(role_type))
    const versionType = Number(version_type);
    if (tipsShowRoleList.includes(Number(role_type))) {
        return defaultTips
    }
    if (versionType === VERSION_TYPE.ENTERPRISE_TRIAL) {// 企业试用版经过降级处理所以给出提示
        return {
            show: true,
            tips: isAdmin ?
                commonLang('当前版本为企业试用版，部分数据和高级功能受限不可用。为保证正常使用，请联系 UMU 客户经理升级为正式版。') :
                commonLang('当前版本为企业试用版，部分数据和高级功能受限不可用。为保证正常使用，请联系系统管理员升级为正式版。')
        }
    }
    if (isExpire) {// 过期
        if (enterpriseList.includes(versionType)) {//企业版-过期一个月内之后会自动讲解
            return {
                show: true,
                tips: isAdmin ? commonLang('您的企业版服务已于 ${dueDate} 到期，为保证后续正常使用，请尽快联系 UMU 客户经理续期。').replace('${dueDate}', dateLabel) :
                    commonLang('您的企业版服务已于 ${dueDate} 到期，为保证后续正常使用，请联系系统管理员尽快续期。').replace('${dueDate}', dateLabel)
            }
        }
        if (instituteList.includes(versionType)) {//机构版过期一个月内
            return {
                show: true,
                tips: isAdmin ? commonLang('您的机构版服务已于 ${dueDate} 到期，为保证后续正常使用，请尽快联系 UMU 客户经理续期。').replace('${dueDate}', dateLabel) :
                    commonLang('您的机构版服务已于 ${dueDate} 到期，为保证后续正常使用，请联系系统管理员尽快续期。').replace('${dueDate}', dateLabel)
            }
        }
        if (commericalList.includes(versionType)) {// 团队版过期
            return {
                show: true,
                tips: isAdmin ? commonLang('您的团队版服务已于 ${dueDate} 到期，部分数据和高级功能受限不可用，续费后将恢复所有数据和功能。').replace('${dueDate}', dateLabel) :
                    commonLang('您的团队版服务已于 ${dueDate} 到期，部分数据和高级功能受限不可用。请联系系统管理员尽快续费，续费后将恢复所有数据和功能。').replace('${dueDate}', dateLabel),
                dueTipsActText: isAdmin ? `${commonLang('立即续费')}` : '',
                actUrls: isAdmin ? onTeamRenewUrls() : ''
            }
        }
    }
    return defaultTips
}
const getEnterpriseExpireStoreKeys = (dayTime: number, userId: string) => {
    return `expireTips${dayTime}${userId}`
}
const EnterpriseExpireTips = (props: IProps) => {
    const { userInfo: { umu_id, enterprise_info } } = props;
    const dayTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000;
    const storeKeys = getEnterpriseExpireStoreKeys(dayTime, umu_id);
    const [isShow, setIsShow] = useState(localStorageHelper.get(storeKeys) !== '1');

    const msg = getEnterpriseExpireMessage(enterprise_info, dayTime)

    const onCloseTipsClick = () => {
        localStorageHelper.set(storeKeys, '1');
        setIsShow(false);
    }

    return <div className='m-enterprise-expire-tips' style={{ display: isShow && msg.show ? '' : 'none' }}>
        <div className='expire-tips-content'>
            <span>{msg.tips}</span>
            {msg.dueTipsActText && <a href={msg.actUrls} className='expire-tips-link'><span>{msg.dueTipsActText}</span><span className="icon-purchase-more"></span></a>}
        </div>
        <div className='expire-tips-close'>
            <div className='expire-icon-tips-close' onClick={onCloseTipsClick}></div>
        </div>
    </div>
}

export {
    EnterpriseExpireTips
}
